import { createFileRoute } from '@tanstack/react-router';
import { UserAuthenticationPage } from '@/features/tenant-admin/pages';

export const Route = createFileRoute('/tenant-admin/authentication')({
  component: UserAuthenticationPage,
});
